import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';

import SignupBonusTiersTable from './SignupBonusTiersTable';
import SignupBonusUpdateButton from './SignupBonusUpdateButton';
import useSignupBonusList from './useSignupBonusList';

export const SignupBonusListTab = () => {
  const {isLoading, fetchList, total, list} = useSignupBonusList();

  return (
    <main className="my-5">
      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierManage}
      >
        <div className="flex justify-end">
          <SignupBonusUpdateButton />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <SignupBonusTiersTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};
